var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.5 4 9 3h6l.5 1H19v2H5V4zM6 7h12v11a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3zm6 5.586-2.121-2.122-1.415 1.415L10.586 14l-2.122 2.121 1.415 1.415L12 15.414l2.121 2.122 1.415-1.415L13.414 14l2.122-2.121-1.415-1.415z"
})));
export default SvgDelete;